'use client';
import { Typography } from '@mcdougald/ui/src';

import CustomLink from '@/components/link';
import WorkExperience from '@/components/resume/experience/experience';
import TestimoniesDataTable from '@/components/resume/references/reference-data-table';
import { AuroraSectionHeading } from '@/components/resume/section-heading';
import { UdemyCourses } from '@/components/resume/udemy';
import { EXPERIENCE_SECTION_IDS, HOME_SECTION_IDS } from '@/constants/routing';
import { SHARE_REFERENCE_GOOGLE_FORM_LINK } from '@/constants/website';

/**
 * Renders:
 * 1. Work Experience
 * 2. References
 *
 * Moving references to be hyperlinked on Experience Page
 */
export const ReferencePage = () => {
  return (
    <>
      <WorkExperience />
      <section
        id={EXPERIENCE_SECTION_IDS.references}
        className="flex flex-col items-center min-h-screen h-auto"
      >
        <AuroraSectionHeading className={'mb-2 font-bold'}>
          References
        </AuroraSectionHeading>
        <div>
          <div>
            <Typography variant={'lg'} className={'text-center'}>
              <CustomLink
                href={SHARE_REFERENCE_GOOGLE_FORM_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className={'underline underline-offset-2 text-blue-300'}
              >
                New references
              </CustomLink>{' '}
              are always appreciated 🙇
            </Typography>
          </div>
          <p className="mt-4 text-lg text-center text-gray-600">
            Below are past testimonials from colleagues and clients.
          </p>
        </div>
        <div className={'max-w-[1300px] w-10/12 mt-8'}>
          <TestimoniesDataTable />
        </div>
        <section
          id={HOME_SECTION_IDS.courses}
          className="udemy-content flex flex-col justify-center w-full z-10 mt-30"
        >
          <UdemyCourses />
        </section>
        {/*<RenderDoubleReferences />*/}
      </section>
    </>
  );
};
